import { DEPLOY_STATUSES } from "../constants";

const { SUCCESS, FAILURE, IN_PROGRESS, REPO_NOT_FOUND, CANCELLED } =
  DEPLOY_STATUSES;

const getDeploymentStatus = (status) => {
  if (!status) return FAILURE;
  status = structuredClone(status);
  delete status.deployedAt;
  const statusValues = Object.values(status);
  if (status.repoNotFound) return REPO_NOT_FOUND;
  else if (statusValues.every((val) => val.status === SUCCESS)) return SUCCESS;
  else if (
    statusValues.some(
      (val) => val.status === CANCELLED || val.status === FAILURE
    )
  )
    return FAILURE;
  else return IN_PROGRESS;
};

export default getDeploymentStatus;
